import React, { useState } from 'react';
import t from 'modules/i18n/intl';
import { getTaaSErrorMessage } from 'modules/checkout/contacts/AddressForm/getTaaSErrorMessage';

import fieldsMeta from '../../checkout/contacts/AddressForm/fieldsMeta';
import { isRequired as checkIsFieldRequired } from '../../checkout/contacts/AddressForm/FormField';

import { Field as AkField, ErrorMessage } from '@atlaskit/form';
import TextField from '@atlaskit/textfield';

export const ContactField = ({ fieldName, label, countries, ...props }) => {
  const [fieldValue, setFieldValue] = useState('');
  const [invalidMessageKey, setInvalidMessageKey] = useState<null | string>(null);

  const defaultValue = props[fieldName];

  const countryData = countries?.find((country) => country.displayName === props.country) || {};
  const isFieldRequired = checkIsFieldRequired({ name: fieldName, country: countryData });
  const fieldMetaKey = fieldName === 'name' ? 'organisationName' : fieldName;

  const fieldMeta = fieldsMeta[fieldMetaKey];

  const handleValidation = () => {
    const isLengthBreach =
      fieldMeta?.characterLimit &&
      fieldMeta?.lengthBreachKey &&
      fieldValue.length > fieldMeta?.characterLimit;

    const isRequiredBreach = isFieldRequired && fieldValue.length === 0;

    if (isRequiredBreach) {
      setInvalidMessageKey('billing.address.validation.required');
    } else if (isLengthBreach) {
      setInvalidMessageKey(getTaaSErrorMessage(fieldMeta?.lengthBreachKey || ''));
    } else {
      setInvalidMessageKey(null);
    }
  };

  const handleChange = (value) => {
    if (value) {
      setFieldValue(value);
    }
  };

  const invalidErrorMessage = invalidMessageKey ? t(invalidMessageKey) : null;

  return (
    <AkField
      name={fieldName}
      testId={fieldName}
      label={label}
      aria-required={isFieldRequired || props.isRequired}
      isRequired={isFieldRequired || props.isRequired}
      defaultValue={defaultValue}
      validate={handleChange}
    >
      {({ fieldProps }) => (
        <>
          <TextField
            autoComplete="off"
            {...fieldProps}
            onBlur={handleValidation}
            isInvalid={!!invalidErrorMessage}
          />
          {invalidErrorMessage ? <ErrorMessage>{invalidErrorMessage}</ErrorMessage> : null}
        </>
      )}
    </AkField>
  );
};

export const FirstName = (props) => (
  <ContactField
    {...props}
    fieldName="firstName"
    label={t('mac.edit-details.contact.firstname')}
    isRequired
  />
);

export const LastName = (props) => (
  <ContactField
    {...props}
    fieldName="lastName"
    label={t('mac.edit-details.contact.lastname')}
    isRequired
  />
);

export const Phone = (props) => (
  <ContactField {...props} fieldName="phone" label={t('mac.edit-details.contact.phone')} />
);

export const CompanyName = (props) => (
  <ContactField
    {...props}
    fieldName="name"
    label={t('mac.edit-details.org.contact.company-name')}
  />
);

export const AddressLine1 = (props) => (
  <ContactField
    {...props}
    fieldName="address1"
    label={t('mac.edit-details.org.contact.address1')}
  />
);

export const AddressLine2 = (props) => (
  <ContactField
    {...props}
    fieldName="address2"
    label={t('mac.edit-details.org.contact.address2')}
  />
);

export const City = (props) => (
  <ContactField {...props} fieldName="city" label={t('mac.edit-details.org.contact.city')} />
);

export const PostCode = (props) => (
  <ContactField
    {...props}
    fieldName="postcode"
    label={t('mac.edit-details.org.contact.postcode')}
  />
);
